import React, { useEffect, useState } from 'react';
import Config from 'config';
import { getLocalData, setLocalData } from 'utils/localDataStore';
import { isBot, getSubdomain } from 'utils/stringUtils';
import qs from 'qs';
import SecurityModal from 'components/SecurityModal';
import Main from 'containers/Main';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';

const getSecurityCheckInfo = ({ config, env, brand }) => {
  // development.crediblemind.com -> check dev_password_required
  // development.crediblemind.com?brand=x -> check dev_password_required && ! no in unprotected clients
  // crediblemind.com -> check prod_password_required
  // crediblemind.com?brand=x -> check prod_protected_clients matches with brand
  // x.crediblemind.com -> check prod_protected_clients matches with brand
  const info = {
    passwordProtected: true,
    password: _get(config, `${env}_password`),
  };
  if (brand && brand !== 'development') {
    const clientsList = _get(
      config,
      `${env}_${env === 'dev' ? 'un' : ''}protected_clients`,
      [],
    );
    const isBrandInList =
      env === 'prod'
        ? clientsList.find(client => _get(client, 'brand') === brand)
        : clientsList.includes(brand);
    if (env === 'prod' && !_isEmpty(isBrandInList)) {
      return {
        ...info,
        password: _get(isBrandInList, 'password'),
      };
    }
    if (!isBrandInList) {
      return info;
    }
    return {};
  }
  if (_get(config, `${env}_password_required`)) return info;
  return {};
};

function HomePageWrapper() {
  const { search } = window.location;
  const [authenticated, setAuthenticated] = useState(
    getLocalData('isAuthenticated'),
  );
  const searchObject = qs.parse(search, {
    ignoreQueryPrefix: true,
  });

  const subdomain = getSubdomain();
  const { pathname } = window.location;
  const env = subdomain === 'development' ? 'dev' : 'prod';
  const closedClients = ['gopro', 'garfield', 'garcopeer', 'a4c'];
  // manually redirect for now, change this once we have ssr
  if (closedClients.includes(subdomain)) {
    window.location.href = 'https://crediblemind.com/?showcorp=1&brand=none';
  }

  if (subdomain === 'owensboro') {
    window.location.href = `https://healthymind.crediblemind.com${pathname}`;
  }

  if (subdomain === 'greenwood') {
    window.location.href = `https://lakelands.crediblemind.com${pathname}`;
  }

  if (subdomain === 'dhec') {
    window.location.href = `https://scdhec.crediblemind.com${pathname}`;
  }

  if (['providence', 'pbh', 'swedish'].includes(subdomain)) {
    window.location.href = `https://choosewell.crediblemind.com${pathname}`;
  }

  if (subdomain === 'testmonterey') {
    window.location.href = `https://wellscreenmonterey.crediblemind.com${pathname}`;
  }

  if (subdomain === 'kaisersanfrancisco') {
    window.location.href = `https://kpsf.crediblemind.com${pathname}`;
  }

  const securityConfig =
    env === 'prod'
      ? _get(Config, 'PROD.SECURITY', null)
      : _get(Config, 'DEV.SECURITY', null);
  const searchBrand = _get(searchObject, 'brand', null);
  const brand = searchBrand || subdomain;
  if (brand && brand !== 'development') {
    setLocalData('brand', brand, {
      expires: 365,
    });
  }
  const { passwordProtected, password } = getSecurityCheckInfo({
    config: securityConfig,
    env,
    brand,
  });
  useEffect(() => {
    const loaderEl = document.getElementById('full-page-loader');
    if (loaderEl) loaderEl.parentNode.removeChild(loaderEl);
  }, []);

  useEffect(() => {
    if (authenticated) {
      setLocalData('isAuthenticated', 'true', {
        expires: 365,
      });
    }
  }, [authenticated]);

  if (
    isBot() ||
    !securityConfig ||
    !passwordProtected ||
    authenticated ||
    !password
  ) {
    return <Main />;
  }

  return (
    <SecurityModal setAuthenticated={setAuthenticated} password={password} />
  );
}

export default HomePageWrapper;
